'use strict';
import {Observable} from 'rxjs/Observable';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {isWebView} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {StreamedComponent} from '../../files/components/Image/ImageContainer';


ImageZoomDialogController.$inject = [
  '$modal',
  '$scope',
  '$timeout',
  '$ionicSlideBoxDelegate',
  'imageUrls',
  'currentIndex',
  '$cordovaStatusbar',
  '$ngRedux',
];

/* TODO: support import list of images to display, if applicable
 * Consider passing the first image as a single url, and the remainder as (optionally) a promise that will resolve to the list of URLs
 * Would need to determine the index of the passed initial URL and then cyclically navigate the list on-swipe
 */
export function ImageZoomDialogController(
  $modal,
  $scope,
  $timeout,
  $ionicSlideBoxDelegate,
  imageUrls,
  currentIndex,
  $cordovaStatusbar,
  $ngRedux,
) {
  const vm = $scope.imageViewer = this;
  let slideBoxDelegate;
  vm.toggleHeader = toggleHeader;
  vm.showPrevious = showPrevious;
  vm.showNext = showNext;
  vm.cancelModal = cancelModal;

  vm.currentIndex = 0;
  vm.zoomMin = 0.25;

  vm.showClose = false;
  vm.hideHeader = false;

  if (isWebView()) {
    $cordovaStatusbar.hide();
  }

  init();

  function toggleHeader() {
    vm.hideHeader = !vm.hideHeader;
  }

  function cancelModal() {
    vm.hideHeader = true;
    vm.showClose = false;
    if (ionic.Platform.isWebView()) {
      $cordovaStatusbar.show();
    }
    $modal.cancel();
  }

  function showPrevious() {
    _getSlideBoxDelegate().previous();
  }

  function showNext() {
    _getSlideBoxDelegate().next();
  }

  function getUrlFromProps(props) {
    return props.url ? props.url : void 0;
  }

  function getIsLoadingFromProps(props) {
    if (props.isLoading) {
      return 'image-loading';
    } else if (props.hasError) {
      return 'image-failed';
    } else {
      return null;
    }
  }

  function init() {
    let init = false;
    $timeout(function () {
      init = true;
      _getSlideBoxDelegate().enableSlide(false);
      slideBoxDelegate.update();
    }, 20, false);

    const list = [];
    for (let i = 0, length = imageUrls.length; i < length; i++) {
      list.push(StreamedComponent($ngRedux.state$, $ngRedux.dispatch)(Observable.of({
        url: imageUrls[i],
        targetHeight: 1024,
        targetWidth: 1024,
        cacheBase64: true,
      })));
    }

    Observable
      .combineLatest(
        ...list,
      )
      .map(allProps => {
        const nextState = {};
        if (allProps.length === 2) {
          // Hack to fix the broken slider
          nextState.allUrls = new Array(4);
          nextState.loadingUrl = new Array(4);

          nextState.allUrls[0] = nextState.allUrls[2] = getUrlFromProps(allProps[0]);
          nextState.loadingUrl[0] = nextState.loadingUrl[2] = getIsLoadingFromProps(allProps[0]);

          nextState.allUrls[1] = nextState.allUrls[3] = getUrlFromProps(allProps[1]);
          nextState.loadingUrl[1] = nextState.loadingUrl[3] = getIsLoadingFromProps(allProps[1]);

        } else {
          nextState.allUrls = new Array(allProps.length);
          nextState.loadingUrl = new Array(allProps.length);

          for (let i = 0, length = allProps.length; i < length; i++) {
            nextState.allUrls[i] = getUrlFromProps(allProps[i]);
            nextState.loadingUrl[i] = getIsLoadingFromProps(allProps[i]);
          }
        }

        return nextState;
      })
      .takeUntil(eventToObservable($scope, SCOPE_DESTROY))
      .subscribe(nextState => {
        $scope.$evalAsync(() => {
          vm.allUrls = nextState.allUrls;
          vm.loadingUrl = nextState.loadingUrl;
        });
      });
  }

  function _getSlideBoxDelegate() {
    return slideBoxDelegate = slideBoxDelegate || $ionicSlideBoxDelegate.$getByHandle('photoZoomModalSlideBox');
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/file-viewer/ImageZoomDialogController.js